import { defineComponent as E, computed as l, useId as V, openBlock as d, createBlock as u, unref as x, normalizeClass as n, withCtx as m, createElementVNode as o, createVNode as q, mergeProps as w, toDisplayString as s, resolveDynamicComponent as C, createTextVNode as g, createCommentVNode as B } from "vue";
import { RevButton as R } from "@ds/components/Button";
import { RevButtonCard as U } from "@ds/components/ButtonCard";
import { RevIllustration as D } from "@ds/components/Illustration";
import { isEmpty as K } from "../../utils/isEmpty.js";
import { tw as a } from "../../utils/tailwind.js";
import { VariantsEnum as P } from "./EditorialCard.constant.js";
const j = { class: "w-full" }, L = /* @__PURE__ */ E({
  name: "RevEditorialCard",
  __name: "EditorialCard",
  props: {
    alt: { default: "" },
    content: { default: "" },
    cta: { default: "" },
    image: {},
    imageProps: { default: () => ({ height: 164, width: 258 }) },
    titleKicker: { default: "" },
    title: {},
    titleTag: {},
    to: {},
    variant: { default: () => P.Default }
  },
  setup(t) {
    const b = l(() => [{
      default: a`md:w-256`,
      full: a`md:w-full`
    }[t.variant]]), y = l(() => {
      const e = [
        a`shadow-short rounded-lg relative flex cursor-pointer overflow-hidden hover:shadow-long`,
        a`motion-safe:transition motion-safe:duration-300 motion-safe:ease-in`
      ], i = {
        default: a`h-[376px] flex-col`,
        full: a`h-[376px] flex-col md:h-[133px] md:flex-row`
      };
      return [e, i[t.variant]];
    }), N = l(() => {
      const e = "object-cover", i = {
        default: a`!h-[168px] w-full`,
        full: a`!h-[168px] w-full md:!h-auto md:w-[250px]`
      };
      return [e, i[t.variant]];
    }), k = l(() => {
      const e = a`bg-float-default-low flex flex-1 justify-between p-24 hover:bg-float-default-low-hover motion-safe:duration-300 motion-safe:ease-in`, i = {
        default: a`flex-col items-start`,
        full: a`grow flex-col items-start md:flex-row md:items-center`
      };
      return [e, i[t.variant]];
    }), p = l(() => [{
      default: a`line-clamp-2`,
      full: a`line-clamp-1`
    }[t.variant], a`text-static-default-hi body-1-bold`]), T = l(() => [{
      default: a`line-clamp-3`,
      full: a`line-clamp-2 md:line-clamp-3`
    }[t.variant]]), $ = l(() => ({
      default: a`text-action-default-hi body-2-link mt-8 hover:text-action-default-hi-hover motion-safe:transition-colors`,
      full: a`md:ml-32 md:max-w-[212px]`
    })[t.variant]), f = l(() => t.variant === "full" ? {
      props: {
        variant: "secondary"
      },
      tag: R
    } : { tag: "span" }), I = l(() => !K(t.cta)), r = V(), c = `title-${r}`, v = `title-kicker-${r}`, h = `cta-${r}`;
    return (e, i) => (d(), u(x(U), {
      "aria-labelledby": `${v} ${c}`,
      class: n(b.value),
      to: t.to
    }, {
      default: m(() => [
        o("article", {
          class: n(y.value)
        }, [
          q(x(D), w(t.imageProps, {
            alt: t.alt,
            class: N.value,
            src: t.image
          }), null, 16, ["alt", "class", "src"]),
          o("div", {
            class: n(k.value)
          }, [
            o("div", j, [
              o("div", {
                id: v,
                class: "text-static-default-low caption truncate"
              }, s(t.titleKicker), 1),
              (d(), u(C(t.titleTag), {
                id: c,
                class: n(p.value)
              }, {
                default: m(() => [
                  g(s(t.title), 1)
                ]),
                _: 1
              }, 8, ["class"])),
              o("p", {
                class: n(["text-static-default-mid body-2 mt-8", T.value])
              }, s(t.content), 3)
            ]),
            I.value ? (d(), u(C(f.value.tag), w({
              key: 0,
              id: h
            }, f.value.props, {
              "aria-labelledby": `${c} ${h}`,
              class: $.value,
              role: "link",
              tabindex: "0"
            }), {
              default: m(() => [
                g(s(t.cta), 1)
              ]),
              _: 1
            }, 16, ["aria-labelledby", "class"])) : B("", !0)
          ], 2)
        ], 2)
      ]),
      _: 1
    }, 8, ["aria-labelledby", "class", "to"]));
  }
});
export {
  L as default
};
